import { FC } from 'react';

import { useTitle } from '../hooks/useTitle';

import Home from 'src/components/templates/Home/Home';

const HomePage: FC = () => {
  useTitle('이웃삼촌 내일도착 배송');
  return <Home />;
};

export default HomePage;
